module.exports = AXELSEN_RANKING = [
    {"date": "2010-01-28", "worldRanking": 209},
    {"date": "2010-02-04", "worldRanking": 209},
    {"date": "2010-02-11", "worldRanking": 209},
    {"date": "2010-03-11", "worldRanking": 209},
    {"date": "2010-03-11", "worldRanking": 210},
    {"date": "2010-03-11", "worldRanking": 217},
    {"date": "2010-03-11", "worldRanking": 220},
    {"date": "2010-03-18", "worldRanking": 220},
    {"date": "2010-03-25", "worldRanking": 218},
    {"date": "2010-04-01", "worldRanking": 221},
    {"date": "2010-04-08", "worldRanking": 222},
    {"date": "2010-04-15", "worldRanking": 227},
    {"date": "2010-04-22", "worldRanking": 233},
    {"date": "2010-04-29", "worldRanking": 233},
    {"date": "2010-05-06", "worldRanking": 234},
    {"date": "2010-05-13", "worldRanking": 234},
    {"date": "2010-05-20", "worldRanking": 235},
    {"date": "2010-05-27", "worldRanking": 235},
    {"date": "2010-06-03", "worldRanking": 237},
    {"date": "2010-06-10", "worldRanking": 237},
    {"date": "2010-06-17", "worldRanking": 238},
    {"date": "2010-06-24", "worldRanking": 237},
    {"date": "2010-07-01", "worldRanking": 235},
    {"date": "2010-07-08", "worldRanking": 235},
    {"date": "2010-07-15", "worldRanking": 240},
    {"date": "2010-07-22", "worldRanking": 239},
    {"date": "2010-07-29", "worldRanking": 241},
    {"date": "2010-08-05", "worldRanking": 238},
    {"date": "2010-08-12", "worldRanking": 236},
    {"date": "2010-08-19", "worldRanking": 236},
    {"date": "2010-08-26", "worldRanking": 236},
    {"date": "2010-09-02", "worldRanking": 237},
    {"date": "2010-09-09", "worldRanking": 212},
    {"date": "2010-09-16", "worldRanking": 215},
    {"date": "2010-09-23", "worldRanking": 222},
    {"date": "2010-09-30", "worldRanking": 221},
    {"date": "2010-10-07", "worldRanking": 166},
    {"date": "2010-10-14", "worldRanking": 128},
    {"date": "2010-10-21", "worldRanking": 98},
    {"date": "2010-10-28", "worldRanking": 83},
    {"date": "2010-11-04", "worldRanking": 64},
    {"date": "2010-11-11", "worldRanking": 59},
    {"date": "2010-11-18", "worldRanking": 59},
    {"date": "2010-11-25", "worldRanking": 59},
    {"date": "2010-12-02", "worldRanking": 59},
    {"date": "2010-12-09", "worldRanking": 60},
    {"date": "2010-12-16", "worldRanking": 61},
    {"date": "2010-12-23", "worldRanking": 62},
    {"date": "2010-12-30", "worldRanking": 66},
    {"date": "2011-01-06", "worldRanking": 66},
    {"date": "2011-01-13", "worldRanking": 66},
    {"date": "2011-01-20", "worldRanking": 66},
    {"date": "2011-01-27", "worldRanking": 66},
    {"date": "2011-02-03", "worldRanking": 66},
    {"date": "2011-02-10", "worldRanking": 66},
    {"date": "2011-02-17", "worldRanking": 66},
    {"date": "2011-02-24", "worldRanking": 67},
    {"date": "2011-03-03", "worldRanking": 67},
    {"date": "2011-03-10", "worldRanking": 69},
    {"date": "2011-03-17", "worldRanking": 69},
    {"date": "2011-03-24", "worldRanking": 63},
    {"date": "2011-03-31", "worldRanking": 62},
    {"date": "2011-04-07", "worldRanking": 63},
    {"date": "2011-04-14", "worldRanking": 62},
    {"date": "2011-04-21", "worldRanking": 63},
    {"date": "2011-04-28", "worldRanking": 64},
    {"date": "2011-05-05", "worldRanking": 66},
    {"date": "2011-05-12", "worldRanking": 57},
    {"date": "2011-05-19", "worldRanking": 59},
    {"date": "2011-05-26", "worldRanking": 47},
    {"date": "2011-06-02", "worldRanking": 46},
    {"date": "2011-06-09", "worldRanking": 46},
    {"date": "2011-06-16", "worldRanking": 46},
    {"date": "2011-06-23", "worldRanking": 35},
    {"date": "2011-06-30", "worldRanking": 34},
    {"date": "2011-07-07", "worldRanking": 34},
    {"date": "2011-07-14", "worldRanking": 34},
    {"date": "2011-07-21", "worldRanking": 33},
    {"date": "2011-07-28", "worldRanking": 33},
    {"date": "2011-08-04", "worldRanking": 33},
    {"date": "2011-08-11", "worldRanking": 31},
    {"date": "2011-08-18", "worldRanking": 33},
    {"date": "2011-08-25", "worldRanking": 33},
    {"date": "2011-09-02", "worldRanking": 33},
    {"date": "2011-09-08", "worldRanking": 32},
    {"date": "2011-09-15", "worldRanking": 33},
    {"date": "2011-09-22", "worldRanking": 35},
    {"date": "2011-09-29", "worldRanking": 35},
    {"date": "2011-10-06", "worldRanking": 36},
    {"date": "2011-10-13", "worldRanking": 37},
    {"date": "2011-10-20", "worldRanking": 44},
    {"date": "2011-10-27", "worldRanking": 39},
    {"date": "2011-11-03", "worldRanking": 43},
    {"date": "2011-11-10", "worldRanking": 44},
    {"date": "2011-11-17", "worldRanking": 44},
    {"date": "2011-11-24", "worldRanking": 34},
    {"date": "2011-12-01", "worldRanking": 35},
    {"date": "2011-12-08", "worldRanking": 36},
    {"date": "2011-12-15", "worldRanking": 36},
    {"date": "2011-12-22", "worldRanking": 36},
    {"date": "2011-12-29", "worldRanking": 35},
    {"date": "2012-01-05", "worldRanking": 35},
    {"date": "2012-01-12", "worldRanking": 35},
    {"date": "2012-01-19", "worldRanking": 31},
    {"date": "2012-01-26", "worldRanking": 36},
    {"date": "2012-02-02", "worldRanking": 36},
    {"date": "2012-02-09", "worldRanking": 36},
    {"date": "2012-02-16", "worldRanking": 36},
    {"date": "2012-02-23", "worldRanking": 29},
    {"date": "2012-03-01", "worldRanking": 30},
    {"date": "2012-03-08", "worldRanking": 30},
    {"date": "2012-03-15", "worldRanking": 29},
    {"date": "2012-03-22", "worldRanking": 25},
    {"date": "2012-03-29", "worldRanking": 25},
    {"date": "2012-04-05", "worldRanking": 25},
    {"date": "2012-04-12", "worldRanking": 25},
    {"date": "2012-04-19", "worldRanking": 24},
    {"date": "2012-04-26", "worldRanking": 22},
    {"date": "2012-05-03", "worldRanking": 21},
    {"date": "2012-05-10", "worldRanking": 21},
    {"date": "2012-05-17", "worldRanking": 21},
    {"date": "2012-05-24", "worldRanking": 22},
    {"date": "2012-05-31", "worldRanking": 22},
    {"date": "2012-06-07", "worldRanking": 22},
    {"date": "2012-06-14", "worldRanking": 22},
    {"date": "2012-06-21", "worldRanking": 29},
    {"date": "2012-06-28", "worldRanking": 24},
    {"date": "2012-07-05", "worldRanking": 24},
    {"date": "2012-07-12", "worldRanking": 24},
    {"date": "2012-07-19", "worldRanking": 24},
    {"date": "2012-07-26", "worldRanking": 24},
    {"date": "2012-08-02", "worldRanking": 24},
    {"date": "2012-08-09", "worldRanking": 24},
    {"date": "2012-08-16", "worldRanking": 23},
    {"date": "2012-08-23", "worldRanking": 23},
    {"date": "2012-08-30", "worldRanking": 23},
    {"date": "2012-09-06", "worldRanking": 23},
    {"date": "2012-09-13", "worldRanking": 24},
    {"date": "2012-09-20", "worldRanking": 25},
    {"date": "2012-09-27", "worldRanking": 24},
    {"date": "2012-10-04", "worldRanking": 25},
    {"date": "2012-10-11", "worldRanking": 25},
    {"date": "2012-10-18", "worldRanking": 25},
    {"date": "2012-10-25", "worldRanking": 31},
    {"date": "2012-11-01", "worldRanking": 25},
    {"date": "2012-11-08", "worldRanking": 25},
    {"date": "2012-11-16", "worldRanking": 25},
    {"date": "2012-11-22", "worldRanking": 26},
    {"date": "2012-11-29", "worldRanking": 27},
    {"date": "2012-12-06", "worldRanking": 27},
    {"date": "2012-12-13", "worldRanking": 26},
    {"date": "2012-12-20", "worldRanking": 26},
    {"date": "2012-12-27", "worldRanking": 27},
    {"date": "2013-01-03", "worldRanking": 27},
    {"date": "2013-01-10", "worldRanking": 26},
    {"date": "2013-01-17", "worldRanking": 22},
    {"date": "2013-01-25", "worldRanking": 22},
    {"date": "2013-01-31", "worldRanking": 22},
    {"date": "2013-02-07", "worldRanking": 22},
    {"date": "2013-02-14", "worldRanking": 22},
    {"date": "2013-02-21", "worldRanking": 22},
    {"date": "2013-02-28", "worldRanking": 22},
    {"date": "2013-03-07", "worldRanking": 21},
    {"date": "2013-03-14", "worldRanking": 22},
    {"date": "2013-03-21", "worldRanking": 23},
    {"date": "2013-03-28", "worldRanking": 23},
    {"date": "2013-04-04", "worldRanking": 23},
    {"date": "2013-04-11", "worldRanking": 23},
    {"date": "2013-04-18", "worldRanking": 23},
    {"date": "2013-04-25", "worldRanking": 22},
    {"date": "2013-05-02", "worldRanking": 21},
    {"date": "2013-05-09", "worldRanking": 19},
    {"date": "2013-05-16", "worldRanking": 19},
    {"date": "2013-05-23", "worldRanking": 19},
    {"date": "2013-05-30", "worldRanking": 17},
    {"date": "2013-06-06", "worldRanking": 17},
    {"date": "2013-06-13", "worldRanking": 17},
    {"date": "2013-06-20", "worldRanking": 19},
    {"date": "2013-06-27", "worldRanking": 23},
    {"date": "2013-07-04", "worldRanking": 23},
    {"date": "2013-07-11", "worldRanking": 23},
    {"date": "2013-07-18", "worldRanking": 22},
    {"date": "2013-07-25", "worldRanking": 22},
    {"date": "2013-08-01", "worldRanking": 22},
    {"date": "2013-08-07", "worldRanking": 22},
    {"date": "2013-08-15", "worldRanking": 23},
    {"date": "2013-08-22", "worldRanking": 23},
    {"date": "2013-08-29", "worldRanking": 22},
    {"date": "2013-09-05", "worldRanking": 22},
    {"date": "2013-09-12", "worldRanking": 21},
    {"date": "2013-09-19", "worldRanking": 21},
    {"date": "2013-09-26", "worldRanking": 22},
    {"date": "2013-10-03", "worldRanking": 21},
    {"date": "2013-10-10", "worldRanking": 21},
    {"date": "2013-10-17", "worldRanking": 21},
    {"date": "2013-10-24", "worldRanking": 19},
    {"date": "2013-10-31", "worldRanking": 24},
    {"date": "2013-11-07", "worldRanking": 24},
    {"date": "2013-11-14", "worldRanking": 24},
    {"date": "2013-11-21", "worldRanking": 25},
    {"date": "2013-11-28", "worldRanking": 24},
    {"date": "2013-12-05", "worldRanking": 23},
    {"date": "2013-12-12", "worldRanking": 24},
    {"date": "2013-12-19", "worldRanking": 23},
    {"date": "2013-12-26", "worldRanking": 23},
    {"date": "2014-01-02", "worldRanking": 23},
    {"date": "2014-01-09", "worldRanking": 23},
    {"date": "2014-01-16", "worldRanking": 24},
    {"date": "2014-01-23", "worldRanking": 24},
    {"date": "2014-01-30", "worldRanking": 25},
    {"date": "2014-02-06", "worldRanking": 25},
    {"date": "2014-02-13", "worldRanking": 25},
    {"date": "2014-02-20", "worldRanking": 26},
    {"date": "2014-02-27", "worldRanking": 26},
    {"date": "2014-03-06", "worldRanking": 26},
    {"date": "2014-03-13", "worldRanking": 26},
    {"date": "2014-03-20", "worldRanking": 18},
    {"date": "2014-03-27", "worldRanking": 18},
    {"date": "2014-04-03", "worldRanking": 18},
    {"date": "2014-04-10", "worldRanking": 15},
    {"date": "2014-04-17", "worldRanking": 14},
    {"date": "2014-04-24", "worldRanking": 16},
    {"date": "2014-05-02", "worldRanking": 14},
    {"date": "2014-05-08", "worldRanking": 15},
    {"date": "2014-05-15", "worldRanking": 15},
    {"date": "2014-05-22", "worldRanking": 15},
    {"date": "2014-05-29", "worldRanking": 18},
    {"date": "2014-06-05", "worldRanking": 18},
    {"date": "2014-06-12", "worldRanking": 17},
    {"date": "2014-06-19", "worldRanking": 15},
    {"date": "2014-06-26", "worldRanking": 14},
    {"date": "2014-07-03", "worldRanking": 16},
    {"date": "2014-07-10", "worldRanking": 16},
    {"date": "2014-07-17", "worldRanking": 16},
    {"date": "2014-07-24", "worldRanking": 16},
    {"date": "2014-07-31", "worldRanking": 16},
    {"date": "2014-08-07", "worldRanking": 16},
    {"date": "2014-08-14", "worldRanking": 16},
    {"date": "2014-08-21", "worldRanking": 16},
    {"date": "2014-08-28", "worldRanking": 16},
    {"date": "2014-09-04", "worldRanking": 12},
    {"date": "2014-09-11", "worldRanking": 11},
    {"date": "2014-09-18", "worldRanking": 10},
    {"date": "2014-09-25", "worldRanking": 10},
    {"date": "2014-10-02", "worldRanking": 10},
    {"date": "2014-10-09", "worldRanking": 11},
    {"date": "2014-10-16", "worldRanking": 11},
    {"date": "2014-10-23", "worldRanking": 14},
    {"date": "2014-10-30", "worldRanking": 13},
    {"date": "2014-11-06", "worldRanking": 13},
    {"date": "2014-11-13", "worldRanking": 13},
    {"date": "2014-11-20", "worldRanking": 12},
    {"date": "2014-11-27", "worldRanking": 11},
    {"date": "2014-12-04", "worldRanking": 11},
    {"date": "2014-12-11", "worldRanking": 11},
    {"date": "2014-12-18", "worldRanking": 10},
    {"date": "2014-12-24", "worldRanking": 12},
    {"date": "2015-01-02", "worldRanking": 12},
    {"date": "2015-01-08", "worldRanking": 12},
    {"date": "2015-01-15", "worldRanking": 11},
    {"date": "2015-01-22", "worldRanking": 10},
    {"date": "2015-01-29", "worldRanking": 9},
    {"date": "2015-02-05", "worldRanking": 9},
    {"date": "2015-02-12", "worldRanking": 9},
    {"date": "2015-02-18", "worldRanking": 9},
    {"date": "2015-02-26", "worldRanking": 9},
    {"date": "2015-03-05", "worldRanking": 7},
    {"date": "2015-03-12", "worldRanking": 6},
    {"date": "2015-03-19", "worldRanking": 6},
    {"date": "2015-03-26", "worldRanking": 6},
    {"date": "2015-04-02", "worldRanking": 6},
    {"date": "2015-04-09", "worldRanking": 6},
    {"date": "2015-04-16", "worldRanking": 6},
    {"date": "2015-04-23", "worldRanking": 6},
    {"date": "2015-04-30", "worldRanking": 9},
    {"date": "2015-05-07", "worldRanking": 9},
    {"date": "2015-05-14", "worldRanking": 9},
    {"date": "2015-05-21", "worldRanking": 9},
    {"date": "2015-05-28", "worldRanking": 9},
    {"date": "2015-06-04", "worldRanking": 5},
    {"date": "2015-06-11", "worldRanking": 6},
    {"date": "2015-06-18", "worldRanking": 6},
    {"date": "2015-06-25", "worldRanking": 6},
    {"date": "2015-07-02", "worldRanking": 6},
    {"date": "2015-07-09", "worldRanking": 6},
    {"date": "2015-07-16", "worldRanking": 6},
    {"date": "2015-07-23", "worldRanking": 7},
    {"date": "2015-07-30", "worldRanking": 7},
    {"date": "2015-08-06", "worldRanking": 7},
    {"date": "2015-08-13", "worldRanking": 7},
    {"date": "2015-08-20", "worldRanking": 6},
    {"date": "2015-08-27", "worldRanking": 6},
    {"date": "2015-09-03", "worldRanking": 6},
    {"date": "2015-09-10", "worldRanking": 6},
    {"date": "2015-09-17", "worldRanking": 6},
    {"date": "2015-09-23", "worldRanking": 7},
    {"date": "2015-10-01", "worldRanking": 7},
    {"date": "2015-10-08", "worldRanking": 7},
    {"date": "2015-10-15", "worldRanking": 7},
    {"date": "2015-10-22", "worldRanking": 7},
    {"date": "2015-10-29", "worldRanking": 7},
    {"date": "2015-11-05", "worldRanking": 6},
    {"date": "2015-11-12", "worldRanking": 6},
    {"date": "2015-11-19", "worldRanking": 5},
    {"date": "2015-11-26", "worldRanking": 6},
    {"date": "2015-12-03", "worldRanking": 6},
    {"date": "2015-12-10", "worldRanking": 6},
    {"date": "2015-12-17", "worldRanking": 6},
    {"date": "2015-12-23", "worldRanking": 6},
    {"date": "2015-12-31", "worldRanking": 6},
    {"date": "2016-01-07", "worldRanking": 6},
    {"date": "2016-01-14", "worldRanking": 6},
    {"date": "2016-01-21", "worldRanking": 6},
    {"date": "2016-01-28", "worldRanking": 6},
    {"date": "2016-02-04", "worldRanking": 6},
    {"date": "2016-02-11", "worldRanking": 6},
    {"date": "2016-02-18", "worldRanking": 6},
    {"date": "2016-02-25", "worldRanking": 6},
    {"date": "2016-03-03", "worldRanking": 6},
    {"date": "2016-03-10", "worldRanking": 6},
    {"date": "2016-03-17", "worldRanking": 5},
    {"date": "2016-03-24", "worldRanking": 6},
    {"date": "2016-03-31", "worldRanking": 6},
    {"date": "2016-04-07", "worldRanking": 6},
    {"date": "2016-04-14", "worldRanking": 5},
    {"date": "2016-04-21", "worldRanking": 5},
    {"date": "2016-04-28", "worldRanking": 4},
    {"date": "2016-05-05", "worldRanking": 4},
    {"date": "2016-05-12", "worldRanking": 4},
    {"date": "2016-05-19", "worldRanking": 4},
    {"date": "2016-05-26", "worldRanking": 4},
    {"date": "2016-06-02", "worldRanking": 4},
    {"date": "2016-06-09", "worldRanking": 4},
    {"date": "2016-06-16", "worldRanking": 4},
    {"date": "2016-06-23", "worldRanking": 4},
    {"date": "2016-06-30", "worldRanking": 4},
    {"date": "2016-07-08", "worldRanking": 4},
    {"date": "2016-07-14", "worldRanking": 4},
    {"date": "2016-07-21", "worldRanking": 4},
    {"date": "2016-07-28", "worldRanking": 4},
    {"date": "2016-08-04", "worldRanking": 4},
    {"date": "2016-08-11", "worldRanking": 4},
    {"date": "2016-08-18", "worldRanking": 4},
    {"date": "2016-08-25", "worldRanking": 4},
    {"date": "2016-09-01", "worldRanking": 4},
    {"date": "2016-09-08", "worldRanking": 4},
    {"date": "2016-09-15", "worldRanking": 4},
    {"date": "2016-09-22", "worldRanking": 4},
    {"date": "2016-09-29", "worldRanking": 4},
    {"date": "2016-10-06", "worldRanking": 4},
    {"date": "2016-10-13", "worldRanking": 4},
    {"date": "2016-10-20", "worldRanking": 4},
    {"date": "2016-10-27", "worldRanking": 5},
    {"date": "2016-11-03", "worldRanking": 4},
    {"date": "2016-11-10", "worldRanking": 4},
    {"date": "2016-11-17", "worldRanking": 4},
    {"date": "2016-11-24", "worldRanking": 4},
    {"date": "2016-12-01", "worldRanking": 4},
    {"date": "2016-12-08", "worldRanking": 4},
    {"date": "2016-12-15", "worldRanking": 4},
    {"date": "2016-12-22", "worldRanking": 3},
    {"date": "2016-12-29", "worldRanking": 3},
    {"date": "2017-01-05", "worldRanking": 3},
    {"date": "2017-01-12", "worldRanking": 3},
    {"date": "2017-01-19", "worldRanking": 3},
    {"date": "2017-01-26", "worldRanking": 3},
    {"date": "2017-02-02", "worldRanking": 3},
    {"date": "2017-02-10", "worldRanking": 3},
    {"date": "2017-02-16", "worldRanking": 3},
    {"date": "2017-02-23", "worldRanking": 3},
    {"date": "2017-03-02", "worldRanking": 3},
    {"date": "2017-03-09", "worldRanking": 4},
    {"date": "2017-03-16", "worldRanking": 4},
    {"date": "2017-03-23", "worldRanking": 4},
    {"date": "2017-03-30", "worldRanking": 4},
    {"date": "2017-04-06", "worldRanking": 2},
    {"date": "2017-04-13", "worldRanking": 3},
    {"date": "2017-04-20", "worldRanking": 2},
    {"date": "2017-04-27", "worldRanking": 2},
    {"date": "2017-05-04", "worldRanking": 3},
    {"date": "2017-05-11", "worldRanking": 3},
    {"date": "2017-05-18", "worldRanking": 3},
    {"date": "2017-05-25", "worldRanking": 3},
    {"date": "2017-06-01", "worldRanking": 3},
    {"date": "2017-06-08", "worldRanking": 2},
    {"date": "2017-06-15", "worldRanking": 2},
    {"date": "2017-06-22", "worldRanking": 3},
    {"date": "2017-06-29", "worldRanking": 3},
    {"date": "2017-07-06", "worldRanking": 3},
    {"date": "2017-07-13", "worldRanking": 3},
    {"date": "2017-07-20", "worldRanking": 3},
    {"date": "2017-07-27", "worldRanking": 3},
    {"date": "2017-08-03", "worldRanking": 3},
    {"date": "2017-08-10", "worldRanking": 3},
    {"date": "2017-08-17", "worldRanking": 3},
    {"date": "2017-08-24", "worldRanking": 3},
    {"date": "2017-08-30", "worldRanking": 2},
    {"date": "2017-09-07", "worldRanking": 2},
    {"date": "2017-09-14", "worldRanking": 2},
    {"date": "2017-09-21", "worldRanking": 2},
    {"date": "2017-09-28", "worldRanking": 1},
    {"date": "2017-10-05", "worldRanking": 1},
    {"date": "2017-10-12", "worldRanking": 1},
    {"date": "2017-10-19", "worldRanking": 1},
    {"date": "2017-10-26", "worldRanking": 1},
    {"date": "2017-11-02", "worldRanking": 1},
    {"date": "2017-11-09", "worldRanking": 1},
    {"date": "2017-11-16", "worldRanking": 1},
    {"date": "2017-11-23", "worldRanking": 1},
    {"date": "2017-11-30", "worldRanking": 1},
    {"date": "2017-12-07", "worldRanking": 1},
    {"date": "2017-12-14", "worldRanking": 1},
    {"date": "2017-12-21", "worldRanking": 1},
    {"date": "2017-12-28", "worldRanking": 1},
    {"date": "2018-01-04", "worldRanking": 1},
    {"date": "2018-01-11", "worldRanking": 1},
    {"date": "2018-01-18", "worldRanking": 1},
    {"date": "2018-01-25", "worldRanking": 1, "worldTourRanking": 3},
    {"date": "2018-02-02", "worldRanking": 1, "worldTourRanking": 3},
    {"date": "2018-02-08", "worldRanking": 1, "worldTourRanking": 6},
    {"date": "2018-02-15", "worldRanking": 1},
    {"date": "2018-02-22", "worldRanking": 1},
    {"date": "2018-03-01", "worldRanking": 1, "worldTourRanking": 9},
    {"date": "2018-03-08", "worldRanking": 1},
    {"date": "2018-03-15", "worldRanking": 1, "worldTourRanking": 12},
    {"date": "2018-03-22", "worldRanking": 1, "worldTourRanking": 18},
    {"date": "2018-03-29", "worldRanking": 1},
    {"date": "2018-04-05", "worldRanking": 1, "worldTourRanking": 21},
    {"date": "2018-04-12", "worldRanking": 2},
    {"date": "2018-04-19", "worldRanking": 1, "worldTourRanking": 22},
    {"date": "2018-04-26", "worldRanking": 1},
    {"date": "2018-05-03", "worldRanking": 1},
    {"date": "2018-05-10", "worldRanking": 1, "worldTourRanking": 24},
    {"date": "2018-05-17", "worldRanking": 1, "worldTourRanking": 25},
    {"date": "2018-05-24", "worldRanking": 1},
    {"date": "2018-05-31", "worldRanking": 1},
    {"date": "2018-06-07", "worldRanking": 1},
    {"date": "2018-06-14", "worldRanking": 1},
    {"date": "2018-06-21", "worldRanking": 1, "worldTourRanking": 32},
    {"date": "2018-06-28", "worldRanking": 1, "worldTourRanking": 33},
    {"date": "2018-07-05", "worldRanking": 1, "worldTourRanking": 22},
    {"date": "2018-07-12", "worldRanking": 1, "worldTourRanking": 8},
    {"date": "2018-07-19", "worldRanking": 1, "worldTourRanking": 10},
    {"date": "2018-07-26", "worldRanking": 1, "worldTourRanking": 13},
    {"date": "2018-08-02", "worldRanking": 1, "worldTourRanking": 13},
    {"date": "2018-08-09", "worldRanking": 1},
    {"date": "2018-08-16", "worldRanking": 1, "worldTourRanking": 13},
    {"date": "2018-08-23", "worldRanking": 1},
    {"date": "2018-08-30", "worldRanking": 1},
    {"date": "2018-09-06", "worldRanking": 1, "worldTourRanking": 13},
    {"date": "2018-09-13", "worldRanking": 1, "worldTourRanking": 13},
    {"date": "2018-09-20", "worldRanking": 1, "worldTourRanking": 10},
    {"date": "2018-09-27", "worldRanking": 3, "worldTourRanking": 11},
    {"date": "2018-10-04", "worldRanking": 3, "worldTourRanking": 11},
    {"date": "2018-10-11", "worldRanking": 3, "worldTourRanking": 11},
    {"date": "2018-10-18", "worldRanking": 3, "worldTourRanking": 11},
    {"date": "2018-10-25", "worldRanking": 4, "worldTourRanking": 11},
    {"date": "2018-11-01", "worldRanking": 4, "worldTourRanking": 14},
    {"date": "2018-11-08", "worldRanking": 4, "worldTourRanking": 15},
    {"date": "2018-11-15", "worldRanking": 4, "worldTourRanking": 18},
    {"date": "2018-11-22", "worldRanking": 4, "worldTourRanking": 19},
    {"date": "2018-11-29", "worldRanking": 4, "worldTourRanking": 20},
    {"date": "2018-12-06", "worldRanking": 4},
    {"date": "2018-12-13", "worldRanking": 4},
    {"date": "2018-12-20", "worldRanking": 6},
    {"date": "2018-12-27", "worldRanking": 6},
    {"date": "2019-01-02", "worldRanking": 6},
    {"date": "2019-01-08", "worldRanking": 6},
    {"date": "2019-01-15", "worldRanking": 6},
    {"date": "2019-01-22", "worldRanking": 6, "worldTourRanking": 6},
    {"date": "2019-01-29", "worldRanking": 6, "worldTourRanking": 2},
    {"date": "2019-02-05", "worldRanking": 6},
    {"date": "2019-02-12", "worldRanking": 6},
    {"date": "2019-02-19", "worldRanking": 6},
    {"date": "2019-02-26", "worldRanking": 6, "worldTourRanking": 1},
    {"date": "2019-03-05", "worldRanking": 6, "worldTourRanking": 1},
    {"date": "2019-03-12", "worldRanking": 4, "worldTourRanking": 1},
    {"date": "2019-03-19", "worldRanking": 4, "worldTourRanking": 1},
    {"date": "2019-03-26", "worldRanking": 4, "worldTourRanking": 1},
    {"date": "2019-04-02", "worldRanking": 4, "worldTourRanking": 1},
    {"date": "2019-04-09", "worldRanking": 3, "worldTourRanking": 1},
    {"date": "2019-04-16", "worldRanking": 3, "worldTourRanking": 1},
    {"date": "2019-04-23", "worldRanking": 3},
    {"date": "2019-04-30", "worldRanking": 3},
    {"date": "2019-05-07", "worldRanking": 3, "worldTourRanking": 1},
    {"date": "2019-05-14", "worldRanking": 3},
    {"date": "2019-05-21", "worldRanking": 3},
    {"date": "2019-05-28", "worldRanking": 3},
    {"date": "2019-06-04", "worldRanking": 3},
    {"date": "2019-06-11", "worldRanking": 3, "worldTourRanking": 1},
    {"date": "2019-06-18", "worldRanking": 3},
    {"date": "2019-06-25", "worldRanking": 3},
    {"date": "2019-07-02", "worldRanking": 3},
    {"date": "2019-07-09", "worldRanking": 5, "worldTourRanking": 1},
    {"date": "2019-07-16", "worldRanking": 5, "worldTourRanking": 1},
    {"date": "2019-07-23", "worldRanking": 5, "worldTourRanking": 1},
    {"date": "2019-07-30", "worldRanking": 5, "worldTourRanking": 3},
    {"date": "2019-08-06", "worldRanking": 6, "worldTourRanking": 3},
    {"date": "2019-08-13", "worldRanking": 6, "worldTourRanking": 3},
    {"date": "2019-08-20", "worldRanking": 6, "worldTourRanking": 3},
    {"date": "2019-08-27", "worldRanking": 7},
    {"date": "2019-09-03", "worldRanking": 7},
    {"date": "2019-09-10", "worldRanking": 7, "worldTourRanking": 4},
    {"date": "2019-09-17", "worldRanking": 7, "worldTourRanking": 4},
    {"date": "2019-09-24", "worldRanking": 7, "worldTourRanking": 5},
    {"date": "2019-10-01", "worldRanking": 7, "worldTourRanking": 6},
    {"date": "2019-10-08", "worldRanking": 7, "worldTourRanking": 6},
    {"date": "2019-10-15", "worldRanking": 7, "worldTourRanking": 6},
    {"date": "2019-10-22", "worldRanking": 6, "worldTourRanking": 4},
    {"date": "2019-10-29", "worldRanking": 5, "worldTourRanking": 5},
    {"date": "2019-11-05", "worldRanking": 6, "worldTourRanking": 5},
    {"date": "2019-11-12", "worldRanking": 5, "worldTourRanking": 5},
    {"date": "2019-11-19", "worldRanking": 5, "worldTourRanking": 5},
    {"date": "2019-11-26", "worldRanking": 5, "worldTourRanking": 5},
    {"date": "2019-12-03", "worldRanking": 5},
    {"date": "2019-12-10", "worldRanking": 5},
    {"date": "2019-12-17", "worldRanking": 5},
    {"date": "2019-12-24", "worldRanking": 5},
    {"date": "2019-12-31", "worldRanking": 5},
    {"date": "2020-01-07", "worldRanking": 5},
    {"date": "2020-01-14", "worldRanking": 4, "worldTourRanking": 3},
    {"date": "2020-01-21", "worldRanking": 3, "worldTourRanking": 1},
    {"date": "2020-01-28", "worldRanking": 3, "worldTourRanking": 4},
    {"date": "2020-02-04", "worldRanking": 3},
    {"date": "2020-02-11", "worldRanking": 3},
    {"date": "2020-02-18", "worldRanking": 5},
    {"date": "2020-02-25", "worldRanking": 5, "worldTourRanking": 1},
    {"date": "2020-03-03", "worldRanking": 5},
    {"date": "2020-03-10", "worldRanking": 7},
    {"date": "2020-03-17", "worldRanking": 4, "worldTourRanking": 1}
]



//////////////////
// WEBPACK FOOTER
// ./static/js/axelsen-ranking.js
// module id = xRI7
// module chunks = 1